const STATUSES = {
  LOCKED: 'SNAPSHOT_LOCKED',
  UNLOCKED: 'SNAPSHOT_CREATED',
  APPROVED: 'SNAPSHOT_APPROVED',
};

export default STATUSES;
